import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function EmotionalSection() {
  const checkoutUrl = 'https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778';
  const partyPhotoUrl = 'https://cdn.magicpatterns.com/uploads/uemY9CkKimryYgGwtLWmr1/o9MBDefGZtGV0uFifunKoGke88OS75JDKHQTOG0yGTEw6_8KsmrCvSGB302D4Kg_yS1vXooDF0rx3pQJOD_u1qwNRcDdsRjFlt7yvfBioq8.jpg';
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="w-full bg-gradient-to-b from-pink-50 to-white py-20 sm:py-28" data-id="element-58">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-59">
        <div className="text-center mb-16" data-id="element-60">
          <motion.h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 mb-4" initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6
        }} data-id="element-61">
            💛 Crea momentos inolvidables
          </motion.h2>
          <motion.p className="text-xl sm:text-2xl font-bold text-rose-500" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-62">
            ✨ Crea cumpleaños mágicos sin gastar una fortuna
          </motion.p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-center bg-white rounded-3xl shadow-xl overflow-hidden border border-rose-100" data-id="element-63">
          {/* Image Side */}
          <motion.div className="w-full lg:w-1/2 h-64 sm:h-80 lg:h-auto relative" initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-64">
            <img src={partyPhotoUrl} alt="Cumpleaños mágico" className="absolute inset-0 w-full h-full object-cover" data-id="element-65" />
          </motion.div>

          {/* Content Side */}
          <div className="w-full lg:w-1/2 p-8 sm:p-12" data-id="element-66">
            <motion.p className="text-xl text-slate-700 mb-8 font-medium" initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.3
          }} data-id="element-67">
              Con este kit puedes decorar fiestas infantiles en minutos.
            </motion.p>

            <motion.div className="flex flex-wrap gap-3 mb-10" initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.4
          }} data-id="element-68">
              <span className="bg-pink-100 text-pink-800 px-4 py-2 rounded-full font-semibold text-sm" data-id="element-69">
                🖨️ Imprime en casa
              </span>
              <span className="bg-pink-100 text-pink-800 px-4 py-2 rounded-full font-semibold text-sm" data-id="element-70">
                🎉 Decora fácil
              </span>
              <span className="bg-pink-100 text-pink-800 px-4 py-2 rounded-full font-semibold text-sm" data-id="element-71">
                💛 Sorprende a tus hijos
              </span>
            </motion.div>

            <motion.div className="space-y-4 mb-8" initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.5
          }} data-id="element-72">
              <p className="text-slate-600 font-medium" data-id="element-73">Este kit te permite:</p>
              <div className="bg-rose-50 p-4 rounded-xl border border-rose-100" data-id="element-74">
                <p className="font-bold text-slate-800 text-lg" data-id="element-75">
                  🎉 Crear cumpleaños mágicos para tus hijos
                </p>
              </div>
              <div className="bg-amber-50 p-4 rounded-xl border border-amber-100" data-id="element-76">
                <p className="font-bold text-slate-800 text-lg" data-id="element-77">
                  💻 O empezar un pequeño negocio desde casa
                </p>
              </div>
            </motion.div>

            <motion.p className="text-slate-600 font-medium mb-8" initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.6
          }} data-id="element-78">
              Todo con archivos digitales fáciles de usar.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.7
          }} data-id="element-79">
              <p className="text-amber-600 font-bold text-lg mb-6" data-id="element-80">
                💡 Todo listo para descargar e imprimir en casa.
              </p>
              <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="shimmer-btn inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-rose-500 to-pink-500 text-white text-lg font-bold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 w-full sm:w-auto" data-id="element-81">
                👉 Acceder al Mega Kit — $27.990 ARS
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}